import { StyleSheet, css } from "aphrodite";
import { primaryColor } from "../theme";
import React, { useState } from "react";
import { width } from "../commonCss/commonCss";
import { FaEye, FaEyeSlash } from "react-icons/fa";

interface InputProps extends React.HTMLAttributes<HTMLInputElement> {
  value?: string;
  type: string;
  placeholder?: string;
  onChangeValue: (val: string) => void;
  widthVal?: string;
}

export const Input = React.memo(
  ({
    type,
    value,
    placeholder,
    className,
    autoFocus,
    onChangeValue,
    widthVal,
  }: InputProps) => {
    const [showPassword, setShowPassword] = useState(false);
    const isPasswordType = type === "password";
    const currentType = isPasswordType ? (showPassword ? "text" : "password") : type;

    return (
      <div className={css(styles.inputContainer, width(widthVal || "20rem")) + (className ? ` ${className}` : "")}>
        <input
          type={currentType}
          onChange={(e) => onChangeValue(e.target.value)}
          autoFocus={autoFocus}
          value={value}
          className={css(styles.input, isPasswordType && styles.inputPassword)}
          placeholder={placeholder}
        />
        {isPasswordType && (
          <div
            className={css(styles.eyeIcon)}
            onClick={() => setShowPassword(!showPassword)}
            title={showPassword ? "Hide password" : "Show password"}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </div>
        )}
      </div>
    );
  }
);

const styles = StyleSheet.create({
  inputContainer: {
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  input: {
    padding: "0.8rem",
    outlineColor: primaryColor,
    width: "100%",
    boxSizing: "border-box",
  },
  inputPassword: {
    paddingRight: "2.5rem",
  },
  eyeIcon: {
    position: "absolute",
    right: "10px",
    cursor: "pointer",
    color: "#666",
    display: "flex",
    alignItems: "center",
  }
});
